import { UPDATE_SGZ_MARKER_REAL_TIME } from "./sgzMarkerRealTimeReducer"

export const updateSgzMarkerRealTime = (info) => ({
    type: UPDATE_SGZ_MARKER_REAL_TIME,
    payload: info
})
